let config = {
	request: {
		// #ifdef H5
		baseUrl: window.location.protocol + "//" + window.location.host+"/api",
		// #endif
		// #ifdef MP || APP-PLUS || APP-PLUS
		baseUrl: "https://baomaishequ.cn/api",
		// #endif
		header: {
			'content-type': 'application/json'
		},
		timeout: 60000,
		dataType: "json",
		responseType: "text"
	}
}

if(process.env.NODE_ENV === "development"){
	// config.request.baseUrl = "http://baomaishequ.com:8888/api";
	// config.request.baseUrl = "http://baomaishequ-ccb.com:8888/api";
	config.request.baseUrl = "https://baomaishequ.cn/api";
}

export default config;